module.exports = __webpack_public_path__ + "img/ddzp.1b291eda.jpg";